import React from 'react';

import HeroSection from './HeroSection';
import WelcomeSection from './WelcomeSection';
import OurMission from './OurMission';
import CurriculumSection from './CurriculumSection';
import PrincipalsMessage from './PrincipalsMessage';
import WhyChoose from './WhyChoose';
import Community from './Community';
import EnrolmentSection from './EnrolmentSection';
import EventsFeedStylized from "../containers/EventsFeedStylized";
import ContactUsSection from './ContactUsSection';

/**
 * Home stitches together the hero video, welcome message, and rolling gallery
 * to provide a snapshot of the Avenue School experience.
 */
const Home = () => {
  return (
    <>
      {/* Hero video and CTA */}
<HeroSection
  headline="Welcome to The Avenue School"
  subheadline="Inspiring Excellence, Building Futures, and Nurturing Minds in Ferntree Gully"
  primaryCta={{ label: "Enrolments", href: "/enrolments" }}
  secondaryCta={{ label: "Contact Us", href: "/contact" }}
  backgroundImage="/media/gallery-7.jpg"
  backgroundColor="#243A24"
/>

<WelcomeSection
  headline="Where education meets empathy, and every student is seen, heard, and supported."
  body={`We are a small, inclusive learning community in Ferntree Gully, designed for young people who have experienced challenges in mainstream education—especially those navigating anxiety, school refusal, or disengagement.<br/><br/>Here, we believe in second chances, personalised learning, and building confidence through connection. Our flexible curriculum, trauma-informed staff, and wellbeing-first approach create a safe space for students to rediscover their love of learning and prepare for meaningful futures.`}
  topImage="/media/light-sage-leaf.png"
  videoId="UDyaAKTPti8"
/>
<OurMission />
<CurriculumSection />
<PrincipalsMessage />
<WhyChoose />
<Community />
<EnrolmentSection />
      <ContactUsSection
        formVariant="enrolment"
        title="Contact us"
        subtitle="Have a question? Get in touch:"
      />
    </>
  );
};
export default Home;
